var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrBadgeCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-badge-check",
    clipPath: "url(#clip0_20193_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0008 9.99999C20.0008 8.64499 19.4058 7.36665 18.3966 6.56332C18.5133 5.21165 18.03 3.88749 17.0716 2.92832C16.1133 1.97082 14.7925 1.48832 13.5075 1.63249C11.8291 -0.497514 8.20331 -0.537514 6.56414 1.60332C5.21081 1.48332 3.88831 1.96915 2.92998 2.92832C1.97248 3.88665 1.48914 5.21165 1.63414 6.49249C-0.495856 8.17082 -0.536689 11.7967 1.60498 13.4367C1.48831 14.7883 1.97164 16.1125 2.92998 17.0717C3.88831 18.0292 5.21081 18.5133 6.49414 18.3675C8.17248 20.4975 11.7983 20.5375 13.4375 18.3967C14.7875 18.51 16.1125 18.0308 17.0716 17.0717C18.0291 16.1133 18.5125 14.7883 18.3675 13.5075C19.4058 12.6342 20.0008 11.3558 20.0008 10.0008V9.99999ZM14.6175 8.80499L10.6683 12.6117C9.69914 13.5792 8.11331 13.5708 7.14414 12.6008L5.26748 10.8575C4.93081 10.5442 4.91081 10.0167 5.22414 9.67999C5.53831 9.34249 6.06664 9.32415 6.40164 9.63665L8.29998 11.4008C8.64831 11.7483 9.17498 11.7475 9.49998 11.4217L13.46 7.60415C13.7916 7.28582 14.3191 7.29499 14.6383 7.62582C14.9583 7.95665 14.9483 8.48499 14.6175 8.80415V8.80499Z",
    fill: "#2E7A0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20193_25745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrBadgeCheck);
export default __webpack_public_path__ + "static/media/fi-sr-badge-check.86a3a7278369671e1db9795a3fe1fd08.svg";
export { ForwardRef as ReactComponent };